import { useQuery } from '@tanstack/react-query';
import { getYearlyBreakdown } from '../services/financeService';

export const useYearlyFinance = (year, calendar) => {
  return useQuery({
    queryKey: ['yearlyFinance', year, calendar],
    queryFn: () => getYearlyBreakdown(year, calendar).then(r => r.data),
    staleTime: 60000, // 60 seconds
    refetchOnWindowFocus: false,
  });
};
